import Product from './Product.js';
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";

export default function ProductCategory(props) {
    const products = props.data.products.map(item => {
        return (
            <Product 
                key={item.productId} 
                data={item} 
                handleProductMenuClick={props.handleProductMenuClick} 
                productCategoryId={props.data.productCategoryId}
            />
        )
    })

    // === begin: Bulk Pricing ===
    // ⚠ The category description is shown ONLY under bulk pricing. That is not a
    // styling choice — on a normal brand this field carries internal text that is
    // not meant for customers. Restyled to wo-cat__sub, gate unchanged.
    let productCategoryDesc;
    if (CommonUtilities.StaticFields.PriceType == 'bp8826') {
        productCategoryDesc = props.data.productCategoryDescription
            ? <p className="wo-cat__sub">{props.data.productCategoryDescription}</p>
            : <></>;
    } else {
        productCategoryDesc = <></>;
    }
    // === end: Bulk Pricing ===

    /* =============================================================================
       One menu category.

       ⚠ The id MUST stay `prodcat{id}`. The scroll-spy navigation, the anchor links
       in MenuNavigation and Bootstrap's own data-bs-spy all target it by that exact
       name. Renaming it breaks category navigation silently — the page still works,
       the nav just stops following.

       ⚠ data-prodcategoryid on the heading is read by the scroll-spy. Keep it.

       The section carries wo-cat, which applies content-visibility so the browser
       skips layout and paint for categories that are off screen. That is what keeps
       a 200-product menu responsive. See theme.css.
       ============================================================================= */
    return (
        <section id={`prodcat${props.data.productCategoryId}`} className="wo-cat">
            <h2 className="wo-cat__head" data-prodcategoryid={props.data.productCategoryId}>
                {props.data.productCategoryName ? props.data.productCategoryName : "Menu"}
            </h2>
            {productCategoryDesc}
            <div className="wo-cards">{products}</div>
        </section>
    )
}